import { Loader } from './Loader';

export const localizedMessagesLoader: { (token?: string): Loader } = (token) => new Loader(token);
